export const brandName = "Amrutha Salon & Tatto Design";

export const phoneNumber = +918978505599;

export const email = "amruthasalon@gmail.com";

export const address1 =
  "Amrutha Salon l Beauty Solutions Plot No. 23, Shop No.2, Seshadri Heights, Prashanth Nagar, Below Punjab National Bank, Vanasthalipuram, Hyderabad 500070, TS";

export const address2 =
  "Amrutha Salon l Beauty Solutions 1st Floor Beside Red Water Tank, Above Wow Colors Vanasthalipuram. Hyd";

export const address1Link = "https://maps.app.goo.gl/xsUEGciZBjUrsakk6";
export const address2Link = "https://maps.app.goo.gl/VnvJfWU52wDX5Fox7";

export const brandUrl = "https://amruthasalon.com/";

export const brandLogo =
  "https://res.cloudinary.com/daelyy9vj/image/upload/v1744978939/amruthalogo_ofobf1.webp";
